import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'EmptyOrderButton',
  emits: ['onClick'],
  setup(__props, { emit: emits }) {



return { __sfc: true,emits }
}

})